import { BaseFormFields } from '@/components/forms/pricing-interface/BaseSchemaFormFields'

export interface RunNPVFormFieldsProps {}

export const RunNPVFormFields: React.FC<RunNPVFormFieldsProps> = ({}) => {
  return (
    <div className={'flex flex-col gap-4'}>
      <BaseFormFields />
    </div>
  )
}
